module.exports = __webpack_public_path__ + "static/media/icon_in.ad2781f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/icon_in.svg
// module id = 151
// module chunks = 0